import axios from 'axios';

const api = '/api/email-messages';

export const getFirstEmailMessage = params => {
  return axios.get(`${api}${params}&cacheBuster=${new Date().getTime()}`);
};

export const getEmailMessage = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const saveEmail = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const uploadAttachment = file => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${api}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteAttachmentById = id => {
  return axios.delete(`${api}/${id}`);
};

export const downloadDocument = async contractDocument => {
  const response = await axios.get(`${api}/download/${contractDocument.id}`, {
    responseType: 'blob', // Important for binary data
  });

  // Create a URL for the blob
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', contractDocument.originalFilename); // Set the original file name
  document.body.appendChild(link);
  link.click();
  link.remove();
};
